<div class="modal-md">
    <div class="modal-content">
        <div class="modal-header border-0 pl-0 pb-0">
        </div>
        <div class="modal-body">
           
            <div class="form-row">                  
                <div class="d-flex justify-content-center">
                    <p>{{message}}</p>
                </div>
            </div>
               

                <div class="form-row">
                  
                    <div class="d-flex justify-content-center">
                        <ul class="pager kg-request-btn text-center">
                            <li>
                                <button type="button" class="btn btn-save" (click)="okClick()">
                                    Ok
                                </button>
                            </li>                           
                        </ul>
                    </div>
                </div>
            
        </div>
    </div>
</div>